import React, { useEffect } from "react";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../help/Api";
import useFormDataCRUD from "../../../../components/Hooks/useEDSCURD";
import GroupAPI, { defaultDG } from "../../../../api/Group";
import Groups from "./groups";
import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import LoadingPage from "../../../../services/LoadingPage";
import { sto } from "../../../../Context/InshData";

export default function GroupsCon() {
  const tb = {
    wait: true,
    Employees: true,
    PermissionsTypeInv: true,
    parms: {
      tree: "sub", iempid: sto.empi, db_name: sto?.db_name,
    },
    autos: { Employees: true },
  };
  const url = uri + "Res";

  const {
    object: data,
    fetching,
    fetch: fetchURL1,
  } = useFetchObjectByPost(url, tb);

  useEffect(() => {
    console.log("data  is", data);
    console.log("data  is", groups);
  });
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `Groups`
  } else {
    Urls = `Groups?db_name=${sto?.db_name}`
  }
  const {
    data: groups,
    fetching: fetchinGroups,
    fetchURL,
  } = useFetchURL({
    ...{
      url: uri + Urls,
    },
  });

  if (fetching || !data || !groups) return <LoadingPage />;

  //   if(fetchinGroups)
  //     return <BackdropScI />
  return (
    <Groups
      {...{
        groups: groups ?? [],
        Employees: data?.auto?.Employees ?? [],
        fetchURL,
        PermType: data?.permType ?? [],
      }}
    />
  );
}
